import { Spin, SpinProps } from 'antd';
import React, { CSSProperties } from 'react';
import AryaLoading from '../AryaLoading';
import styles from './styles.module.pcss';

type Props = { indicatorStyles?: CSSProperties } & SpinProps;

const MobileLoader: React.FC<Props> = ({ size, spinning, children, indicatorStyles }) => {
  return (
    <div className={styles.loader}>
      <Spin spinning={spinning} size={size} indicator={<AryaLoading containerStyles={indicatorStyles} />}>
        {children}
      </Spin>
    </div>
  );
};

export const getAryaTableLoading = (loading?: boolean) => {
  return {
    spinning: !!loading,
    indicator: <AryaLoading />,
  };
};

export default MobileLoader;
